import { ICreateUserRequestModel } from "@lib/types";
import { Organization } from "../organization";
import { ICreateUserAccount } from "./createUserAccount";

export interface ICreateUser {
  email: string;
  firstName: string;
  lastName: string;
  isOrganizationAdmin: boolean;
  accounts: Array<ICreateUserAccount>;
}

export class CreateUser implements ICreateUser {
  email: string;
  firstName: string;
  lastName: string;
  isOrganizationAdmin: boolean;
  accounts: ICreateUserAccount[];

  constructor(
    email: string,
    firstName: string,
    lastName: string,
    isOrganizationAdmin: boolean,
    accounts: ICreateUserAccount[],
  ) {
    this.email = email;
    this.firstName = firstName;
    this.lastName = lastName;
    this.isOrganizationAdmin = isOrganizationAdmin;
    this.accounts = accounts;
  }

  static create(
    formData: FormData,
    accounts: Array<ICreateUserAccount>,
  ): CreateUser {
    const email = formData.get("email") as string;
    const firstName = formData.get("firstName") as string;
    const lastName = formData.get("lastName") as string;
    const isOrganizationAdmin =
      formData.get("organization-select") === Organization.ORGANIZATION_OWNER;

    return new CreateUser(
      email,
      firstName,
      lastName,
      isOrganizationAdmin,
      accounts,
    );
  }

  toRequestModel(): ICreateUserRequestModel {
    return {
      email: this.email,
      first_name: this.firstName,
      last_name: this.lastName,
      is_organization_admin: this.isOrganizationAdmin,
      accounts: this.accounts,
    };
  }
}
